<template>
    <rkm-alert
        v-if="inconsistencias.length > 0"
        color="danger"
    >
        <ul class="m-0 px-3">
            <li
                v-for="(inconsistencia, i) in inconsistencias"
                :key="i"
            >
                {{ inconsistencia }}
            </li>
        </ul>
    </rkm-alert>
</template>

<script>
export default {
    props: {
        inconsistencias: { type: Array, required: true },
    },
}
</script>